export var HOLDING_REPORT = "HOLDING_REPORT_REVAMP";
export var OMNE_ONLY = " OMNE_ONLY";
export var FILTER_DATA = "FILTER_DATA";
export var SORT_DATA = "SORT_DATA";
export var SUMMARIZE = "SUMMARIZE";
export var SEARCH = "SEARCH";
export var QUANTITY_BREAKDOWN = "QUANTITY_BREAKDOWN";
export var SCREENSTATE = "SCREENSTATE";
export var SELECTED_STOCK = "SELECTED_STOCK";
